import { ShiftsState } from './index'

const shifts = (state: ShiftsState) => state.shifts
const shiftsRequest = (state: ShiftsState) => state.shiftsRequest

export default {
  shifts,
  shiftsRequest,
}
